import { gql } from "@apollo/client";

export const EXPORT_UNSHIPPED_ORDERS_TO_CSV = gql`
  mutation ExportUnshippedOrdersToCsv($input: ExportUnshippedOrderInput!) {
    exportUnshippedOrdersToCsv(input: $input) {
      downloadURL
      error
    }
  }
`;

export const EXPORT_ORDERS_TO_CSV = gql`
  mutation ExportOrdersToCsv($input: ExportOrderInput!) {
    exportOrdersToCsv(input: $input) {
      downloadURL
      error
    }
  }
`;

export const IMPORT_ORDER_FULFILLMENTS_FRAGMENT = gql`
  fragment ImportOrderFulfillmentsFragment on ImportOrderFulfillmentsFromCsvResult {
    importedItems
    error
  }
`;

export const IMPORT_ORDER_FULFILLMENTS_FROM_CSV = gql`
  mutation ImportOrderFulfillmentsFromCsv($file: Upload!, $format: String!) {
    importOrderFulfillmentsFromCsv(file: $file, format: $format) {
      ...ImportOrderFulfillmentsFragment
    }
  }
  ${IMPORT_ORDER_FULFILLMENTS_FRAGMENT}
`;

export const AUTO_ORDER_FULFILLMENTS = gql`
  mutation AutoOrderFulfillments {
    autoOrderFulfillments {
      processedOrderCount
    }
  }
`;

export const MARK_ORDERS_AS_DELIVERED = gql`
  mutation MarkOrdersAsDelivered($orderIds: [ID!]!) {
    markOrdersAsDelivered(orderIds: $orderIds) {
      updatedFulfillmentCount
      skippedFulfillmentCount
      errorCount
    }
  }
`;